import { gql } from '__generated__';

export default gql(`
  mutation CleanupCurrentUser {
    cleanupCurrentUser
  }
`);
